import { createAsyncTypes } from 'store/utils';

// State Key
export const KEY = 'hardware';

// Action Types
export const types = {
  GET_HARDWARE: createAsyncTypes(`${KEY}/GET_HARDWARE`),
  CREATE_HARDWARE: createAsyncTypes(`${KEY}/CREATE_HARDWARE`),
  UPDATE_HARDWARE: createAsyncTypes(`${KEY}/UPDATE_HARDWARE`),
  DELETE_HARDWARE: createAsyncTypes(`${KEY}/DELETE_HARDWARE`),
  RESET_HARDWARE: `${KEY}/RESET_HARDWARE`,
  RESET_ACTION: `${KEY}/RESET_ACTION`,
  RESET_ERROR: `${KEY}/RESET_ERROR`
};

export interface HardwareState {
  readonly hardware: Hardware[];
  readonly action: {
    readonly success: boolean;
    readonly pending: boolean;
    readonly error: string | null;
  };
}

export interface Hardware {
  id: string;
  name: string;
  code: string;
  type: string;
  details: Record<string, string>;
  imageUrl?: string;
}

export interface CreateHardwarePayload {
  type: string;
  name: string;
  code: string;
}

export interface CreateHardwareRequest {
  type: typeof types.CREATE_HARDWARE.REQUEST;
  payload: CreateHardwarePayload;
}

export interface ResetHardware {
  type: typeof types.RESET_HARDWARE;
}

export interface GetHardwareError {
  type: typeof types.GET_HARDWARE.ERROR;
  payload: string;
}

export interface GetHardwarePending {
  type: typeof types.GET_HARDWARE.PENDING;
  payload: boolean;
}

export interface GetHardwareSuccess {
  type: typeof types.GET_HARDWARE.SUCCESS;
  payload: Hardware[];
}

export type UpdateHardwarePayload = Partial<Hardware> & { id: string };

export interface UpdateHardwareRequest {
  type: typeof types.UPDATE_HARDWARE.REQUEST;
  payload: UpdateHardwarePayload;
}

export interface UpdateHardwareError {
  type: typeof types.UPDATE_HARDWARE.ERROR;
  payload: string;
}

export interface UpdateHardwarePending {
  type: typeof types.UPDATE_HARDWARE.PENDING;
  payload: boolean;
}

export interface UpdateHardwareSuccess {
  type: typeof types.UPDATE_HARDWARE.SUCCESS;
  payload: Hardware;
}

export interface CreateHardwareRequest {
  type: typeof types.CREATE_HARDWARE.REQUEST;
  payload: CreateHardwarePayload;
}

export interface CreateHardwareError {
  type: typeof types.CREATE_HARDWARE.ERROR;
  payload: string;
}

export interface CreateHardwarePending {
  type: typeof types.CREATE_HARDWARE.PENDING;
  payload: boolean;
}

export interface CreateHardwareSuccess {
  type: typeof types.CREATE_HARDWARE.SUCCESS;
}

export interface DeleteHardwareRequest {
  type: typeof types.DELETE_HARDWARE.REQUEST;
  payload: { id: string };
}

export interface DeleteHardwareError {
  type: typeof types.DELETE_HARDWARE.ERROR;
  payload: string;
}

export interface DeleteHardwarePending {
  type: typeof types.DELETE_HARDWARE.PENDING;
  payload: boolean;
}

export interface DeleteHardwareSuccess {
  type: typeof types.DELETE_HARDWARE.SUCCESS;
}

export type HardwareActionTypes =
  | ResetHardware
  | GetHardwareSuccess
  | GetHardwareError
  | GetHardwarePending
  | UpdateHardwareRequest
  | UpdateHardwareSuccess
  | UpdateHardwareError
  | UpdateHardwarePending
  | CreateHardwareRequest
  | CreateHardwareSuccess
  | CreateHardwareError
  | CreateHardwarePending
  | DeleteHardwareRequest
  | DeleteHardwareSuccess
  | DeleteHardwareError
  | DeleteHardwarePending;
